module.exports = require('./SearchProviderView');module.exports = require('./SearchProviderView');